/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Limitdescription1Inputs */

const zh_learn_limitdescription1 = /** @type {(inputs: Learn_Limitdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已经用完了该分享允许的全部完成次数。`)
};

const en_learn_limitdescription1 = /** @type {(inputs: Learn_Limitdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have already used all allowed completions for this shared session.`)
};

const es_learn_limitdescription1 = /** @type {(inputs: Learn_Limitdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya has usado todos los completados permitidos para esta sesión compartida.`)
};

/**
* | output |
* | --- |
* | "You have already used all allowed completions for this shared session." |
*
* @param {Learn_Limitdescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_limitdescription1 = /** @type {((inputs?: Learn_Limitdescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Limitdescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_limitdescription1(inputs)
	if (locale === "en") return en_learn_limitdescription1(inputs)
	return es_learn_limitdescription1(inputs)
});
export { learn_limitdescription1 as "learn_limitDescription" }